var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'module-button-' + _vm.dModule.id}},[_c('div',{class:_vm.dModule.layout.alignment},[_c('a',{staticClass:"button blank-href",style:(_vm.buttonStyle),attrs:{"href":_vm.dModule.data.redirectTarget,"target":_vm.dModule.data.redirectType}},[_vm._v(" "+_vm._s(_vm.dModule.data.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }